const STORAGE_KEY_PREFIX = 'edify-assistant-pending-image'

export function getImageStorageKey(sessionId?: string, userId?: string): string {
  const parts = [STORAGE_KEY_PREFIX]
  if (userId) parts.push(`user-${userId}`)
  if (sessionId) parts.push(sessionId)
  return parts.join('-')
}

export function getPendingImage(sessionId?: string, userId?: string): string | null {
  try {
    const key = getImageStorageKey(sessionId, userId)
    return localStorage.getItem(key)
  } catch {
    return null
  }
}

export async function setPendingImageFromBlob(
  blob: Blob,
  sessionId?: string,
  userId?: string
): Promise<void> {
  return new Promise((resolve) => {
    const reader = new FileReader()
    reader.onloadend = () => {
      try {
        const dataUrl = reader.result as string
        const key = getImageStorageKey(sessionId, userId)
        localStorage.setItem(key, dataUrl)
      } catch (e) {
        console.warn('Error saving pending image to localStorage:', e)
      }
      resolve()
    }
    reader.readAsDataURL(blob)
  })
}

export function clearPendingImage(sessionId?: string, userId?: string): void {
  try {
    const key = getImageStorageKey(sessionId, userId)
    localStorage.removeItem(key)
  } catch {
    //
  }
}

export function hasPendingImage(sessionId?: string, userId?: string): boolean {
  return getPendingImage(sessionId, userId) !== null
}

function dataURLtoFile(dataurl: string): File {
  const arr = dataurl.split(',')
  const mime = arr[0].match(/:(.*?);/)?.[1] || 'image/jpeg'
  const ext = mime.startsWith('video/') ? (mime.includes('webm') ? 'webm' : 'mp4') : 'jpg'
  const filename = mime.startsWith('video/') ? `video.${ext}` : 'image.jpg'
  const bstr = atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], filename, { type: mime })
}

export function getPendingImageAsFile(
  sessionId?: string,
  userId?: string
): File | null {
  const dataUrl = getPendingImage(sessionId, userId)
  if (!dataUrl) return null
  try {
    return dataURLtoFile(dataUrl)
  } catch {
    return null
  }
}
